export default __webpack_public_path__ + "static/assets/fa779b8155288e744cf05b89813151af.png";